import { mapValues } from 'lodash'


const getValuesFromProps = (props, fieldOptions) =>
  mapValues(fieldOptions, (opts, fieldName) => {
    const propValue = props[fieldName]
    return typeof propValue !== 'undefined' ? propValue : (opts.fields ? {} : '')
  })


export default getValuesFromProps
